import { render } from "./layout-dark.vue?vue&type=template&id=2421932c"
import script from "./layout-dark.vue?vue&type=script&lang=js"
export * from "./layout-dark.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__